export default  {
    knobX: 84,
    knobY: 84,
    svg:`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="208px" height="208px" viewBox="0 0 208 208" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="c3cf4491-a5b1-a5a3-e75f-693f986e74a9">
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#000000" stop-opacity="0.5" offset="100%"/>
        </linearGradient>
        <circle id="57f97660-e20a-04a6-af0c-960e950c964c" cx="100" cy="100" r="100"/>
        <filter x="-3.5%" y="-3.0%" width="107.0%" height="107.0%" filterUnits="objectBoundingBox" id="82617f69-60ab-8d7d-0f9a-502a7d67a06d">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <circle id="eab48280-96c8-aadc-5e81-e08dfe7f0477" cx="100" cy="100" r="88"/>
        <filter x="-4.0%" y="-3.4%" width="108.0%" height="108.0%" filterUnits="objectBoundingBox" id="7c6f0572-2417-3b0b-c601-1bbac6f29e89">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="978ac39e-86a9-40a6-8a41-82c8962fff5b">
            <stop stop-color="#EEEEEE" offset="0%"/>
            <stop stop-color="#EDEDED" offset="50.0553592%"/>
            <stop stop-color="#D8D8D8" offset="100%"/>
        </linearGradient>
        <circle id="1acfd4ea-9ef2-e76c-16e6-5eab1587759e" cx="84" cy="84" r="84"/>
        <filter x="-4.2%" y="-3.6%" width="108.3%" height="108.3%" filterUnits="objectBoundingBox" id="8b3bbec0-eca3-056b-a76c-c747706828f8">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <circle id="956d8be8-e704-dc17-35a6-45a1e8e4887b" cx="84" cy="84" r="60"/>
        <filter x="-2.1%" y="-2.1%" width="104.2%" height="104.2%" filterUnits="objectBoundingBox" id="0cc824bd-dcb0-d568-da5a-a0280ba8c31a">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="41.8108259%" gradientTransform="translate(0.500000,0.500000),scale(0.994048,1.000000),rotate(-90.000000),translate(-0.500000,-0.500000)" id="bbec3cd3-534d-c510-7356-a8a925dc459a">
            <stop stop-color="#3D3D3D" offset="0%"/>
            <stop stop-color="#979191" offset="100%"/>
        </radialGradient>
        <ellipse id="3375be22-dc77-8d7f-1798-62b9dc85496f" cx="84.502994" cy="11" rx="10.0598802" ry="10"/>
        <filter x="-9.9%" y="-10.0%" width="119.9%" height="120.0%" filterUnits="objectBoundingBox" id="0fe9e801-ef09-759d-2cca-f7f1d9dee14f">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <ellipse id="2b479c63-de78-09b9-0c30-19f498765be0" cx="84.502994" cy="11" rx="7.52774751" ry="7.48293949"/>
        <filter x="-19.9%" y="-20.0%" width="139.9%" height="140.1%" filterUnits="objectBoundingBox" id="b5aeedb7-be3b-6ee6-abca-5f3e187b798d">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.960784314   0 0 0 0 0.650980392   0 0 0 0 0.137254902  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        
        <filter x="-6.6%" y="-13.9%" width="113.1%" height="127.9%" filterUnits="objectBoundingBox" id="256c8d73-6233-51e6-1ca6-dbb46a6ef880">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.960784314   0 0 0 0 0.650980392   0 0 0 0 0.137254902  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s7" transform="translate(4.000000, 3.000000)">
            <g id="container">
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#82617f69-60ab-8d7d-0f9a-502a7d67a06d)" xlink:href="#57f97660-e20a-04a6-af0c-960e950c964c"/>
                    <use stroke="#979797" stroke-width="1" fill="url(#c3cf4491-a5b1-a5a3-e75f-693f986e74a9)" fill-rule="evenodd" xlink:href="#57f97660-e20a-04a6-af0c-960e950c964c"/>
                </g>
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#7c6f0572-2417-3b0b-c601-1bbac6f29e89)" xlink:href="#eab48280-96c8-aadc-5e81-e08dfe7f0477"/>
                    <use stroke="#4A4A4A" stroke-width="1" fill="#4A4A4A" fill-rule="evenodd" xlink:href="#eab48280-96c8-aadc-5e81-e08dfe7f0477"/>
                </g>
                <g id="knob" transform="translate(16.000000, 16.000000)">
                    <g id="Oval-2">
                        <use fill="black" fill-opacity="1" filter="url(#8b3bbec0-eca3-056b-a76c-c747706828f8)" xlink:href="#1acfd4ea-9ef2-e76c-16e6-5eab1587759e"/>
                        <use stroke="#979797" stroke-width="1" fill="url(#978ac39e-86a9-40a6-8a41-82c8962fff5b)" fill-rule="evenodd" xlink:href="#1acfd4ea-9ef2-e76c-16e6-5eab1587759e"/>
                    </g>
                    <g id="Oval">
                        <use fill="#3D3D3D" fill-rule="evenodd" xlink:href="#956d8be8-e704-dc17-35a6-45a1e8e4887b"/>
                        <use fill="black" fill-opacity="1" filter="url(#0cc824bd-dcb0-d568-da5a-a0280ba8c31a)" xlink:href="#956d8be8-e704-dc17-35a6-45a1e8e4887b"/>
                        <use stroke="#454545" stroke-width="1" xlink:href="#956d8be8-e704-dc17-35a6-45a1e8e4887b"/>
                    </g>
                    <g id="Oval-3">
                        <use fill="url(#bbec3cd3-534d-c510-7356-a8a925dc459a)" fill-rule="evenodd" xlink:href="#3375be22-dc77-8d7f-1798-62b9dc85496f"/>
                        <use fill="black" fill-opacity="1" filter="url(#0fe9e801-ef09-759d-2cca-f7f1d9dee14f)" xlink:href="#3375be22-dc77-8d7f-1798-62b9dc85496f"/>
                    </g>
                    <g id="Oval-4">
                        <use fill="black" fill-opacity="1" filter="url(#b5aeedb7-be3b-6ee6-abca-5f3e187b798d)" xlink:href="#2b479c63-de78-09b9-0c30-19f498765be0"/>
                        <use fill="#3D3D3D" fill-rule="evenodd" xlink:href="#2b479c63-de78-09b9-0c30-19f498765be0"/>
                    </g>
                </g>
                <g id="label" transform="translate(55.000000, 79.000000)" fill="#F5A623" fill-opacity="1">
                    <g id="labeltext">
                        <text id="d01297d6-5572-5beb-9f7a-62437caab2c3" font-family="Helvetica" font-size="36" font-weight="normal" fill="#F5A623" class="text-16" filter="url(#256c8d73-6233-51e6-1ca6-dbb46a6ef880)">
            <tspan x="0" y="35">10.10</tspan>
        </text>
                        <text id="f45de531-f84c-f86a-c9d6-417c9bdc0996" font-family="Helvetica" font-size="36" font-weight="normal" fill="#F5A623" class="text-16">
            <tspan x="0" y="35">10.10</tspan>
        </text>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`,
updateAttributes: [
    {
      element: "#labeltext text tspan",
      content: (props, value) => {
        return value.toFixed(0);
      },
      attrs: [
        {
          name: "text-anchor",
          value: (props, value) => {
            return "middle";
          }
        },
        {
          name: "x",
          value: (props, value) => {
            return "43";
          }
        }
      ]
    }
  ]
}